import { css } from "@compiled/react";
import { UniformSlot } from "@uniformdev/canvas-react";

import { media } from "@atlaskit/primitives";

import {
    ResponsiveGapOptions,
    ResponsiveOrientationOptions
} from "../../container/src/container";

export interface UniformSingleTabProps {
    title: string;
    iconUrl?: string;
    orientation?: ResponsiveOrientationOptions;
    gap?: ResponsiveGapOptions;
}

// eslint-disable-next-line complexity
const UniformSingleTab = (props: UniformSingleTabProps) => {
    const { orientation = { mobile: "vertical" }, gap = { mobile: "0" } } =
        props;

    const gapObject: ResponsiveGapOptions = {
        mobile: gap.mobile ?? "0",
        // @ts-ignore
        tablet: gap?.tablet ?? gap.mobile ?? "0",
        // @ts-ignore
        desktop: gap?.desktop ?? gap?.tablet ?? gap.mobile ?? "0"
    };

    const styles = css({
        width: "100%",
        height: "auto",
        display: "flex",
        gap: "var(--ds-space-" + gapObject.mobile + ")",
        [media.above.sm]: {
            gap: "var(--ds-space-" + gapObject.tablet + ")"
        },
        [media.above.md]: {
            gap: "var(--ds-space-" + gapObject.desktop + ")"
        }
    });

    const orientationObject: ResponsiveOrientationOptions = {
        mobile: orientation.mobile || "vertical",
        // @ts-ignore
        tablet: orientation.tablet || orientation.mobile || "vertical",
        desktop:
            // @ts-ignore
            orientation.desktop ||
            // @ts-ignore
            orientation.tablet ||
            orientation.mobile ||
            "vertical"
    };
    const orientationStyle = css({
        display: "flex",
        flexDirection:
            orientationObject.mobile === "horizontal" ? "row" : "column",
        [media.above.sm]: {
            flexDirection:
                orientationObject.tablet === "horizontal" ? "row" : "column"
        },
        [media.above.md]: {
            flexDirection:
                orientationObject.desktop === "horizontal" ? "row" : "column"
        }
    });

    return (
        <div css={[styles, orientationStyle]}>
            <UniformSlot name="tabContents" />
        </div>
    );
};

export default UniformSingleTab;
